import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import bulkItems from './bulkItems';

export default (ids, value, filterData, callback) => (dispatch) => {
    const dataAlert = {
        confirmText: 'Eliminar',
        haveTextCaptcha: true,
        messages: [
            i18next.t('Are you sure to remove {{count}} element?', {
                count: ids.length,
            }),
        ],
        onSuccess: () => dispatch(bulkItems(ids, value, filterData, callback)),
        textToValidate: 'ELIMINAR',
        title: 'Confirmación',
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
